import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./ProductsPage.css";
import Footer from "./footer";
import Spinner from "../components/Spinner";

export default function SearchPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(location.search);
  const query = queryParams.get("q") || "";

  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("token");
  const API_BASE = process.env.REACT_APP_API_URL || "https://api.goharesadaf.ir";

  useEffect(() => {
    if (!query) return;

    setLoading(true);
    fetch(`${API_BASE}/api/search?q=${encodeURIComponent(query)}`)
      .then((res) => {
        if (!res.ok) throw new Error("خطا در جستجو!");
        return res.json();
      })
      .then((data) => setResults(data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, [query]);

  return (
    <div className="products-page">
      <div className="content-wrapper">
        <section className="products-hero">
          <h1 className="search-page-title">
            نتایج جستجو برای: <span className="breadcrumb-box">{query}</span>
          </h1>
        </section>

        {loading && <Spinner />}
        {error && <p>خطا: {error}</p>}

        {!loading && !error && (
          <section className={`ProductsPageProductGrid ${results.length === 0 ? "no-results-wrapper" : ""}`}>
            {results.length === 0 ? (

              <div className="no-results">
                <img
                  src="/images/noProductFound.png" // place your image in public/images/
                  alt="No products found"
                  className="no-results-image"
                />
                <p className="no-results-text">نتیجه‌ای یافت نشد!</p>
              </div>

            ) : (results.map((product) => (
              <div
                className="ProductsPageProductCard"
                key={product.id}
                onClick={() => navigate(`/product/${product.id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="image-wrapper">
                  <img
                    src={product.main_image || "/images/placeholder.png"}
                    alt={product.title}
                  />
                </div>
                <h3 className="ProductsPageDescription">{product.title}</h3>
                <p className="ProductsPagePrice">
                  {product.price
                    ? `${parseFloat(product.price).toLocaleString("fa-IR")} تومان`
                    : "قیمت ندارد"}
                </p>
              </div>
            ))
            )}
          </section>
        )}
      </div>
      <Footer />
    </div>
  );
}
